module.exports = __webpack_public_path__ + "static/media/icon-leads.a8561513.svg";